import React from 'react';
import {TableHead,TableRow,withStyles} from '@material-ui/core';
import TableHeaderSortButton from '../common/TableHeaderSortButton';
import ProceduresManualContext from './ProceduresManualContext';
import MuiTableCell from "@material-ui/core/TableCell";

const TableCell = withStyles({
    root: (props) => ({
      paddingLeft: 10,
      paddingBottom: 5,
      paddingTop: 5,
    }),
  })(MuiTableCell);

const ProceduresManuaTableHeader = (props) => {

    const titleProperties = [
        { 
            title:"SDN",
            property: "sdn"
        },
        { 
            title:"Title",
            property: "title"
        },
        { 
            title:"Category",
            property: "categoryName"
        },        
        {  
            title:"Rev",
            property: "rev"
        },
        {  
            title:"Comply as-is?",
            property: "applicability"
        },
        {  
            title:"Reasoning",
            property: "deviationReasoning",
            hideForReadOnly:true,
        },
        {  
            title:"Status",
            property: "status"
        },
    ]

    const context = React.useContext(ProceduresManualContext);

    const {actionGroupForDisplayedProcedureManual = {}} = context.procedureManual;
    const {readOnly} = actionGroupForDisplayedProcedureManual;

    return (
        <TableHead>
            <TableRow >
            <TableCell style={{padding:`0px 0px 0px 10px`}}>
                    <div />
                </TableCell>               
                {titleProperties.map(titleProperty => (
                (readOnly && titleProperty.hideForReadOnly) ? null :
                    <TableCell>
                        <TableHeaderSortButton 
                                title={titleProperty.title}
                                property={titleProperty.property}
                                propertyToSortBy={context.sortProperty}
                                sortReverse={context.sortReverse}
                                onClick={property=>{context.setSortProperty(property)}}
                        />
                        
                    </TableCell>
               ))}
            </TableRow>
        </TableHead>
    );
   

}

export default ProceduresManuaTableHeader;